import React, { useCallback, useEffect, useRef } from 'react';

const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || '';
const ADSENSE_SLOT_LEFT = process.env.REACT_APP_ADSENSE_SLOT_LEFT || '';
const ADSENSE_SLOT_RIGHT = process.env.REACT_APP_ADSENSE_SLOT_RIGHT || '';

let scriptLoaded = false;

function loadAdSenseScript(client) {
  if (scriptLoaded || !client || typeof document === 'undefined') return;
  if (document.querySelector('script[data-adsense]')) {
    scriptLoaded = true;
    return;
  }
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
  s.crossOrigin = 'anonymous';
  s.setAttribute('data-adsense', '1');
  document.head.appendChild(s);
  scriptLoaded = true;
}

export default function AdSlot({ side = 'left' }) {
  const insRef = useRef(null);
  const pushed = useRef(false);
  const timerRef = useRef(0);

  const slot = side === 'left' ? ADSENSE_SLOT_LEFT : ADSENSE_SLOT_RIGHT;
  const client = ADSENSE_CLIENT;
  const configured = Boolean(client && slot);

  const pushAd = useCallback(() => {
    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
      pushed.current = true;
    } catch (err) {
      // Script not ready yet — retry
      timerRef.current = window.setTimeout(pushAd, 400);
    }
  }, []);

  useEffect(() => {
    if (!configured || pushed.current) return undefined;
    loadAdSenseScript(client);
    pushAd();
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [configured, client, pushAd]);

  if (configured) {
    return (
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', height: '600px' }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
        data-testid={`ad-slot-${side}`}
      />
    );
  }

  return (
    <div
      className="h-full w-full flex flex-col items-center justify-center text-center px-3"
      data-testid={`ad-slot-${side}-placeholder`}
    >
      <span className="text-[10px] uppercase tracking-widest text-slate-400 dark:text-slate-500">Advertisement</span>
      <span className="text-[9px] mt-2 text-slate-400 dark:text-slate-600 max-w-[140px] leading-relaxed">
        Configure REACT_APP_ADSENSE_CLIENT &amp; slot IDs to enable Google AdSense
      </span>
    </div>
  );
}
